import axios from "@/lib/axios";

const getCommercialLens = () => {
  return axios.get("/facility/orders/commercial_lens");
}

export default getCommercialLens;